// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toolbar-marketing-banner[data-v-08006924]{background:linear-gradient(90deg,#5d20dd 21.58%,#d225a2 54.63%,#bb15b5 95.24%);box-sizing:border-box;height:100%;left:0;position:absolute;top:0;width:100vw;z-index:510}.toolbar-marketing-banner .close-btn[data-v-08006924]{height:32px;width:32px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
